import { render, staticRenderFns } from "./only-content.vue?vue&type=template&id=da25371e"
import script from "./only-content.vue?vue&type=script&lang=js"
export * from "./only-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderSimple: require('C:/cata1og/cata1og-store/components/header/header-simple.vue').default,FooterSimple: require('C:/cata1og/cata1og-store/components/footer/footer-simple.vue').default,SidebarAccount: require('C:/cata1og/cata1og-store/components/sidebar/account.vue').default})
